import { gotoUrl, postUrl } from 'src/store/actions/actionUtils';
import { meldinger_path, oppgaver_path, type RedirectParams } from 'src/types/url';

// Function to decode and clean the context parameter
export function cleanContextParameter(contextParameter?: string): string {
  return decodeURIComponent(contextParameter || '')
    .replace(/[^A-Za-z0-9+\-\s]/g, '') // Allow only valid characters
    .trim();
}

function getRedirectParams(
  contextParamParsed?: string,
  redirectParams?: RedirectParams
): { contextParameter?: string; dokumentGuid?: string; taskId?: string; resourceId?: string; resourceIdType?: string; returURL?: string } {
  return {
    ...(contextParamParsed && { contextParameter: contextParamParsed }),
    ...(redirectParams?.documentGuid && { dokumentGuid: redirectParams.documentGuid }),
    ...(redirectParams?.taskId && { taskId: redirectParams.taskId }),
    ...(redirectParams?.returnUrl && { returURL: redirectParams.returnUrl }),
  };
}

export function handleRedirect(redirectPath: string, contextParamParsed: string, redirectParams: RedirectParams): void {
  const params = getRedirectParams(contextParamParsed, redirectParams);
  const queryParams = buildQueryString(params);
  const pathWithParams = appendQueryParamsToUrl(redirectPath, queryParams);
  gotoUrl(pathWithParams);
}

export function handlePostRequest(
  redirectPath: string,
  postParams: Record<string, string | undefined>,
  contextParamParsed: string,
  redirectParams?: RedirectParams
): void {
  // Merge post parameters with redirect parameters
  const mergedParams = {
    ...postParams,
    ...getRedirectParams(contextParamParsed, redirectParams),
  };
  postUrl(redirectPath, mergedParams);
}

function buildQueryString(params: Record<string, string | undefined>): string {
  return Object.entries(params)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');
}

function appendQueryParamsToUrl(baseUrl: string, queryParams: string): string {
  if (!queryParams) return baseUrl;

  return baseUrl.includes('?')
    ? `${baseUrl}&${queryParams}` // Eksisterende query
    : `${baseUrl}?${queryParams}`; // Ny query string
}

export const createReturnUrl = (harGuidanceAction: boolean | undefined): string | undefined => {
  if (harGuidanceAction) {
    const currentUrl = new URL(window.location.href);
    const returnUrl = encodeURIComponent(`${currentUrl.pathname}${currentUrl.search}`);

    return returnUrl;
  }
};

export const redirectToMeldingssenter = (samtaleGuid: string): void => {
  const baseUrl = new URL(window.location.origin).origin;
  const samtaleUrl = `${baseUrl}${meldinger_path}${samtaleGuid}`;
  gotoUrl(samtaleUrl);
};

export const redirectToOppgaveSenter = (taskId: string): void => {
  const baseUrl = new URL(window.location.origin).origin;
  const oppgaveUrl = `${baseUrl}${oppgaver_path}${taskId}`;
  gotoUrl(oppgaveUrl);
};
